// extracted by mini-css-extract-plugin
export var closeButton = "_hl-1";
export var closeX = "_hl-3";
export var container = "_hl-0";
export var image = "_hl-2";